export default __webpack_public_path__ + "static/266-e48c757552c95412277dbae1ebf48b1d.gif";